module.exports = __webpack_public_path__ + "assets/images/c7afb60179fd8f9c4ad8195316e5291a.png";